var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-lazy',{attrs:{"transition":"fade-transition"}},[(_vm.hasItems)?_c('vue-horizontal-list',{attrs:{"items":_vm.getItems,"options":_vm.options},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('title-card',{attrs:{"item":item}})]}}],null,false,4049562761)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }